import React, { createContext, useContext, useEffect, useState } from "react";

const CurrencyCtx = createContext({ currency: "PHP", rate: 60.8047, toggle: () => {} });

export function CurrencyProvider({ children, rate = 60.8047 }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem("bc_currency") || "PHP");
  useEffect(() => { localStorage.setItem("bc_currency", currency); }, [currency]);
  const toggle = () => setCurrency((c) => (c === "PHP" ? "USD" : "PHP"));
  return (
    <CurrencyCtx.Provider value={{ currency, setCurrency, toggle, rate }}>
      {children}
    </CurrencyCtx.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyCtx);

// format a canonical PHP integer into the active currency
export function useMoney() {
  const { currency, rate } = useCurrency();
  return (php) => {
    if (php == null) return "Custom";
    if (currency === "USD") {
      const usd = php / rate;
      return "$" + usd.toLocaleString("en-US", { maximumFractionDigits: 0 });
    }
    return "\u20b1" + php.toLocaleString("en-PH");
  };
}
